import { useQuery } from "@tanstack/react-query";

import { moduleKeys } from "../../../../redux/services/moduleTypeKeys";

import { getModuleListApiCall } from "./utils.api";

export const useGetModuleTypeList = (params) =>
  useQuery({
    queryKey: moduleKeys.getModuleKeys(params),
    queryFn: () => getModuleListApiCall(params),
  });
